module.exports = __webpack_public_path__ + "static/media/Hopinion.f219aaea.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/Hopinion.png
// module id = 47
// module chunks = 0